import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VisualPlannerLayer from "../components/VisualPlannerLayer";

const VisualPlannerPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Visual Planner">
        {/* VisualPlannerLayer */}
        <VisualPlannerLayer />
      </MasterLayout>
    </>
  );
};

export default VisualPlannerPage;
